import { CSSObject } from '@emotion/css';

import { inlineTextLinkStyle } from '../links';

export const linkStyles: CSSObject = {
  '& a': inlineTextLinkStyle,
};
